import styled from 'styled-components'

const Button = styled.button`
  position: fixed;
  right: 1rem;
  z-index: 10;
  font-size: 2rem;
  color: #fff;
  background-color: ${({ theme }) => theme.primary_btn};
  border-radius: 100vmax;
  border: none;
  padding: 0.2rem;
  cursor: pointer;
  display: grid;
  place-items: center;

  &.hidden {
    visibility: hidden;
  }

  &.scroll-arrow__down {
    bottom: 2rem;
  }
  
  &.scroll-arrow__up {
    top: 2rem;
  }
`

export { Button }
